<template>
  <div>
    <GChart
      :settings="{ packages: ['corechart', 'sankey'] }"
      type="Sankey"
      :data="chartData"
      :options="chartOptions"
      style="width: 1200px; height: 500px;"
      @ready="onChartReady"
      ref="gChart"
    />

  </div>

</template>

<script>

    import { GChart } from "vue-google-charts";

    export default {
      name: "SankeyChart",
      components: {
        GChart
      },
      data() {
        return {
          chartData: null,
          chartOptions: {
            width: 1200,
            height: 500
          }
        };
      },
      methods: {
        onChartReady(chart, google) {
          // now we have google lib loaded. Let's create data table based using it.
          this.createDataTable(chart, google);
        },
        // Array will be automatically processed with visualization.arrayToDataTable function
        createDataTable(chart, google) {

          var data = new google.visualization.DataTable();
          data.addColumn('string', 'From');
          data.addColumn('string', 'To');
          data.addColumn('number', 'Weight');
          data.addColumn({type: 'string', role: 'tooltip'});
          data.addRows([
            [ 'A 2010', 'A 2011', 5,'Bureau of Investigative Journalism launched'],
            [ 'B 2010', 'A 2013', 1,'Corruption at BAE Systems David Leigh and Rob Evan (Guardian)'],
            [ 'C 2010', 'C 2011', 3,'Politicians for Hire, Dispatches'],
            [ 'D 2010', 'C 2011', 5,'Iraq War Logs, Wikileaks (and others)'],
            [ 'A 2011', 'A 2012', 2,'2011 Al Jazera\'s Africa Investigates Strand'],
            [ 'B 2011', 'A 2012', 2,'2011 Drone Attacks in Pakistan, Bureau of Investigative Journalism'],
            [ 'C 2011', 'A 2012', 2,'2011 Phonehacking, Nick Davies and Guardian'],
            [ 'A 2012', 'A 2013', 5,'2012 Eliot Higgins expose of weapons used in Syrian War'],
            [ 'A 2013', 'A 2014', 2,'2013 NSA Files - The Guardian'],
            [ 'A 2014', 'A 2015', 3,'2014 Bellingcat launched'],
            [ 'A 2015', 'A 2016', 1,'2015 Buzzfeed develops international "investigative" unit, including London team'],
            [ 'A 2016', 'A 2018', 2,'2016 International Consortium of Investigative Journalists release Panama Papers'],
            [ 'A 2018', 'A 2019', 1,'2018 Guardian. Windrush scandal. Amelia Gentleman.'],
            [ 'A 2018', 'A 2019', 1,'Channel 4 News. Cambridge Analytica.'],
            [ 'A 2019', 'A 2020', 1,'']
          ]);

          var view = new google.visualization.DataView(data);
          chart.draw(view, this.chartOptions);
        }
      }
    }
</script>

<style scoped>

</style>
